import { starterPrompts } from "../shared/constants.js";

export function StarterPrompts({ setPrompt }: { setPrompt: (prompt: string) => void }) {
  return (
    <section className="welcome-suggestions" aria-label="推荐问题">
      <p className="starter-label">你可以这么问我：</p>
      <div className="starter-grid">
        {starterPrompts.map((item) => (
          <button key={item.title} type="button" onClick={() => setPrompt(item.prompt)}>
            <strong>{item.title}</strong>
            <span>{item.tag}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
